// `Popover.Trigger asChild` wraps the caller's trigger in a non-focusable
// `YStack`; focusing that wrapper on close no-ops and focus falls to `<body>`.
// Resolve the caller's focusable trigger instead. Pure read → unit-testable.
const FOCUSABLE_SELECTOR =
  '[tabindex]:not([tabindex="-1"]),a[href],button,input,select,textarea,[role="combobox"]';

export const getReturnFocusTarget = (
  wrapper: HTMLElement | null,
): HTMLElement | null => {
  if (wrapper === null) {
    return null;
  }
  if (wrapper.matches(FOCUSABLE_SELECTOR)) {
    return wrapper;
  }
  const focusable = wrapper.querySelector(FOCUSABLE_SELECTOR);
  return focusable instanceof HTMLElement ? focusable : null;
};
